import { useState } from 'react';
import { translate } from '../../i18n';
import ComplianceSelectBox from './ComplianceSelectBox';
import EditStaffCompliance from './ComplianceForm';
import ViewStaffComplianceForm from './ViewStaffComplianceForm';
import VehicleAndTrailerForm from '../ui/VeichleAndTrailerForm';
import { IUpdateStaffInEquipmentCompliance } from '../../type/updateStaffInEquipment';
import complianceApi from '../../api/complianceApi';
import useLocationStore from '../../store/locatonStore';
import { COMPLIANCE_STATUS } from '../../constants/constant';

type AirCraftComplianceCardProps = {
  compliance?: string;
  category: string;
  status: string;
  allocatedTo: string;
  nextComplianceDateDisplay?: string;
  complianceDescription?: string;
  isEditable?: boolean;
  allocatedStaffId?: number;
  onStaffChange?: (staffId: number) => void;
  recurrency?: string;
  lastComplianceDateDisplay?: string;
  nextComplianceDate?: string;
  name?: string;
  note?: string;
  closeModal: () => void;
  complianceId?: number;
  equipmentId?: number;
  equipmentTypeId?: number;
  refetchComplianceDetails: () => void;
  editPermissionForBalloonCompliance?: boolean;
  upcomingDays?: number;
};

export default function AirCraftComplianceCard({
  nextComplianceDate,
  note,
  equipmentTypeId,
  equipmentId,
  complianceId,
  compliance,
  category,
  status,
  allocatedTo,
  nextComplianceDateDisplay,
  complianceDescription,
  isEditable = false,
  allocatedStaffId,
  onStaffChange,
  recurrency,
  lastComplianceDateDisplay,
  refetchComplianceDetails,
  editPermissionForBalloonCompliance,
  upcomingDays,
}: AirCraftComplianceCardProps) {
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const setSelectedLocation = useLocationStore(
    (state) => state.setSelectedLocation,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCloseModal = () => setIsModalOpen(false);

  const updateStaffInStaffCompliance = async (
    data: IUpdateStaffInEquipmentCompliance[],
  ) => {
    try {
      const response =
        await complianceApi.updateStaffInEquipmentCompliance(data);
      console.log(response);
      refetchComplianceDetails();
    } catch (error) {
      console.log(error);
    }
  };

  const handleStaffChange = (selectedStaffId: number) => {
    const data: IUpdateStaffInEquipmentCompliance = {
      complianceId: complianceId,
      equipmentId: equipmentId,
      equipmentTypeId: equipmentTypeId,
      allocStaffId: selectedStaffId,
      ownerId: selectedLocation.OwnerId,
    };
    updateStaffInStaffCompliance([data]);
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-6 gap-x-6 text-start text-sm">
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">Compliance</p>
        <p className="text-text-black">{category}</p>
      </div>
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">Category</p>
        <p className="text-text-black">{complianceDescription}</p>
      </div>
      <div onClick={() => setIsModalOpen(true)} className="flex flex-col">
        <p className="font-medium text-textColorGray">Status</p>
        <p
          className={`${
            editPermissionForBalloonCompliance ? 'underline decoration-2' : ''
          } ${
            (upcomingDays ?? 0) <= 7
              ? 'text-red-500'
              : (upcomingDays ?? 0) <= 30
                ? 'text-yellow-500'
                : 'text-gray-700'
          }`}
        >
          {nextComplianceDateDisplay}
        </p>
      </div>

      <div className="flex flex-col w-[70%] mt-4">
        <label className="block text-sm font-medium text-textColorGray text-start">
          Allocated to
        </label>
        <ComplianceSelectBox
          allocatedTo={allocatedTo}
          disabled={!isEditable}
          allocatedStaffId={allocatedStaffId}
          onChange={(e) => {
            console.log(Number(e.target.value), 'Number(e.target.value)');
            onStaffChange?.(Number(e.target.value));
            handleStaffChange(Number(e.target.value));
          }}
          isEditMode={isEditable}
        />
      </div>
      {isModalOpen && editPermissionForBalloonCompliance && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center px-4">
          <VehicleAndTrailerForm
            compliance={compliance}
            name={allocatedTo}
            category={category}
            recurrency={recurrency}
            status={nextComplianceDateDisplay}
            closeModal={handleCloseModal}
            equipmentId={equipmentId}
            complianceId={complianceId}
            note={note}
            equipmentTypeId={equipmentTypeId}
            nextComplianceDate={nextComplianceDate}
            lastComplianceDateDisplay={lastComplianceDateDisplay}
            onSubmitSuccess={refetchComplianceDetails}
          />
        </div>
      )}
    </div>
  );
}
